<!-- <template>
    <div>
      <v-container>
        <v-card class="task-list-card" elevation="2">
          <v-card-title>
            <span class="headline">Tareas Pendientes</span>
          </v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item v-for="(task, index) in tasks" :key="index">
                <v-list-item-content>
                  <v-list-item-title>{{ task.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ task.dueDate }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-checkbox v-model="task.completed" @change="toggleTaskCompletion(index)"></v-checkbox>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="addTask">Nueva Tarea</v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </div>
  </template>
  
  <script>
  import Swal from "sweetalert2";
  export default {
    data() {
      return {
        tasks: [
          { name: "Revisar reporte semanal", dueDate: "2024-12-25", completed: false },
          { name: "Actualizar documentación", dueDate: "2024-12-26", completed: true },
          { name: "Planificar reunión de equipo", dueDate: "2024-12-27", completed: false },
        ],
      };
    },
    methods: {
      addTask() {
        Swal.fire({
          title: "Nueva Tarea",
          input: "text",
          inputLabel: "Nombre de la tarea",
          showCancelButton: true,
          confirmButtonText: "Agregar",
          preConfirm: (taskName) => {
            if (!taskName) {
              Swal.showValidationMessage("Por favor ingresa el nombre de la tarea");
            }
            return taskName;
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.tasks.push({ name: result.value, dueDate: "Sin fecha", completed: false });
            Swal.fire("Tarea agregada", "", "success");
          }
        });
      },
      toggleTaskCompletion(index) {
        this.tasks[index].completed = !this.tasks[index].completed;
      },
    },
  };
  </script>
  
  <style>
  .task-list-card {
    margin: 2rem auto;
    max-width: 600px;
  }
  .headline {
    font-size: 1.6rem;
    color: #424242;
  }
  </style>

  <template>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="d-flex justify-space-between align-center">
          <h1 class="font-weight-bold">Team Dashboard</h1>
          <v-btn text>Home</v-btn>
          <v-btn text>Tasks</v-btn>
          <v-btn text>Reports</v-btn>
          <v-btn text>Settings</v-btn>
        </v-col>
      </v-row>
  
      <v-row>
        <v-col cols="12" md="8">
          <v-card outlined>
            <v-card-title>Pending Tasks</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-card v-for="(task, index) in tasks" :key="index" class="mb-4 elevation-1" outlined>
                <v-card-title>{{ task.title }}</v-card-title>
                <v-card-text>
                  Assigned to: <strong>{{ task.assignedTo }}</strong> | Due Date: <strong>{{ task.dueDate }}</strong>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" dark @click="markAsCompleted(index)">Mark as Completed</v-btn>
                </v-card-actions>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>
  
        <v-col cols="12" md="4">
          <v-card outlined class="mb-4">
            <v-card-title>Completion Rate</v-card-title>
            <v-card-text>
              <v-img src="https://via.placeholder.com/150" alt="Completion Rate"></v-img>
            </v-card-text>
          </v-card>
  
          <v-card outlined class="mb-4">
            <v-card-title>Tasks Over Time</v-card-title>
            <v-card-text>
              <v-img src="https://via.placeholder.com/150" alt="Tasks Over Time"></v-img>
            </v-card-text>
          </v-card>
  
          <v-card outlined>
            <v-card-title>Team Member Activity</v-card-title>
            <v-card-text>
              <v-img src="https://via.placeholder.com/150" alt="Team Member Activity"></v-img>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        tasks: [
          {
            title: "Design New Landing Page",
            assignedTo: "Alex Johnson",
            dueDate: "Dec 20, 2023",
          },
          {
            title: "Develop API Integration",
            assignedTo: "Maria Silva",
            dueDate: "Jan 10, 2024",
          },
          {
            title: "Conduct User Testing",
            assignedTo: "Liam Wang",
            dueDate: "Feb 5, 2024",
          },
        ],
      };
    },
    methods: {
      markAsCompleted(index) {
        this.tasks.splice(index, 1);
      },
    },
  };
  </script>
 -->
 <template>
  <v-container>
    <!-- Encabezado -->
    <v-row>
      <v-col>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Gestión de Tareas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="openDialog">
            <v-icon left>mdi-plus</v-icon> Nueva Tarea
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>

    <!-- Lista de Tareas -->
    <v-row>
      <v-col cols="12" md="8" class="mx-auto">
        <v-list two-line>
          <v-list-item
            v-for="(task, index) in tasks"
            :key="task.id"
            class="mb-2"
          >
            <v-list-item-avatar>
              <v-icon
                :color="task.estado === 'Completada' ? 'green' : 'blue'"
              >
                mdi-clipboard-check-outline
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ task.titulo }}</v-list-item-title>
              <v-list-item-subtitle>{{ task.descripcion }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon color="primary" @click="editTask(task)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="red" @click="deleteTask(task)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <!-- Modal para Nueva Tarea -->
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline">Nueva Tarea</v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="newTask.titulo"
              label="Título de la Tarea"
              outlined
              required
            ></v-text-field>
            <v-textarea
              v-model="newTask.descripcion"
              label="Descripción"
              outlined
            ></v-textarea>
            <v-select
              v-model="newTask.estado"
              :items="['Pendiente', 'En Progreso', 'Completada']"
              label="Estado"
              outlined
            ></v-select>
            <v-select
              v-model="newTask.assigned_to"
              :items="users"
              item-text="nombre"
              item-value="id"
              label="Asignar a"
              outlined
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="closeDialog">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="saveTask">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export default {
  data() {
    return {
      dialog: false,
      tasks: [],
      users: [],
      newTask: {
        titulo: "",
        descripcion: "",
        estado: "Pendiente",
        assigned_to: null,
      },
      auth:null
    };
  },
  methods: {
    fetchTasks() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(
              RUTA_API + "/TeamTaskViewSet/",
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              
            })
            .catch((res) => {

            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
      /* try {
        const response = await axios.get("/api/tareas/");
        this.tasks = response.data;
      } catch (error) {
        console.error("Error al cargar tareas:", error);
      } */
    },
    async fetchUsers() {
      try {
        const response = await axios.get("/api/usuarios/");
        this.users = response.data;
      } catch (error) {
        console.error("Error al cargar usuarios:", error);
      }
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.resetTask();
    },
    resetTask() {
      this.newTask = {
        titulo: "",
        descripcion: "",
        estado: "Pendiente",
        assigned_to: null,
      };
    },
    async saveTask() {
      if (!this.newTask.titulo || !this.newTask.assigned_to) {
        alert("Por favor completa los campos requeridos.");
        return;
      }

      try {
        await axios.post("/api/tareas/", this.newTask);
        this.closeDialog();
        this.fetchTasks();
      } catch (error) {
        console.error("Error al guardar tarea:", error);
      }
    },
    editTask(task) {
      console.log("Editar tarea:", task);
      // Lógica para editar tareas
    },
    deleteTask(task) {
      console.log("Eliminar tarea:", task);
      // Lógica para eliminar tareas
    },
  },
  mounted() {
    this.fetchTasks();
    this.fetchUsers();
  },
};
</script>

<style scoped>
.v-toolbar {
  margin-bottom: 20px;
}
.v-list-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.v-list-item-avatar .v-icon {
  font-size: 32px;
}
</style>